import { initial } from "@/api/app";
import { loadBranding } from "@/composables/useBranding";
import { unreadCount, ticketsUnreadCount } from "@/api/portal";
import { openCount as ticketsOpenCount } from "@/api/tickets";
import { useAuthStore, usePortalStore } from "@/stores";
import { ref } from "vue";

export default () => {
  const isFetching = ref(false);

  const success = async (response) => {
    if (response.status != 200) {
      return false;
    }
    // Hook for bootstrap data the app needs after login.
  };

  const failed = async (error) => {
    console.log(error);
  };

  const execute = async () => {
    isFetching.value = true;
    await initial().then(success, failed);
    // Load business/portal branding (logo, name, currency) app-wide.
    await loadBranding();

    // Sidebar badges: unread notifications (clients) / open tickets (admins).
    const authStore = useAuthStore();
    const role = authStore.user?.role;
    if (role === 'client') {
      const portalStore = usePortalStore();
      try {
        const { data } = await unreadCount();
        portalStore.setUnread(data.unread_count);
      } catch (e) { /* non-fatal */ }
      try {
        const { data } = await ticketsUnreadCount();
        portalStore.setUnreadTickets(data.unread_count);
      } catch (e) { /* non-fatal */ }
    } else if (role === 'admin' || role === 'super_admin') {
      try {
        const { data } = await ticketsOpenCount();
        usePortalStore().setOpenTickets(data.count);
      } catch (e) { /* non-fatal */ }
    }

    isFetching.value = false;
  };

  return {
    execute,
    isFetching,
  };
};
